import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Button from 'react-bootstrap/Button';
import ReactPaginate from 'react-paginate';
import imgpos from '../../img/pos2.png';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import { useDispatch, useSelector } from 'react-redux';
import { reportHandler, businessHandler, branchHandler } from '../../redux/handlers';

function getCurrentDate(separator = '', dateb = new Date()) {
  let newDate = dateb;
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}

function getCurrentDateM(separator = '') {
  let d = new Date();

  let newDate = new Date(d.setMonth(d.getMonth() - 1));
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}

export function ReportSales() {
  const navigate = useNavigate();
  const [reportdata, setreportdata] = useState([]);
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const reportData = useSelector(state => state.report.saleReport);
  const [searchdata, setSearchdata] = useState({
    branchID: '',
    posIS: '',
    startDate: getCurrentDateM('/'),
    endDate: getCurrentDate('/')
  });
  const [pos, setPos] = useState([]);
  const [branch, setBranch] = useState([]);
  const [posBranchObj, setPosBranchObj] = useState(null);
  const [optionsPos, setOptionsPos] = useState([]);
  const [businessId, setBusinessId] = useState(null);
  const [posSelected, setPosSelected] = useState([]);
  const [optionsBranch, setOptionsBranch] = useState([]);
  const firstLoad = useRef(true);

  // Pagination state
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const paginationComponentOptions = {
    rowsPerPageText: 'จำนวนรายการต่อหน้า',
    rangeSeparatorText: 'of',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All'
  };

  const CurrencyFormatC = ({ val }) => {
    return (
      <CurrencyFormat
        value={val}
        decimalScale={2}
        fixedDecimalScale={true}
        displayType={'text'}
        thousandSeparator={true}
        prefix={''}
      />
    );
  };

  const columns = [
    {
      name: 'วันที่ POS',
      selector: row => row.posDate,
      width: '110px'
    },
    {
      name: 'ยอดรวม',
      width: '110px',
      selector: row => row.total,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.total} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>ITEM</div>
        </div>
      ),
      selector: row => row.discountItem,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discountItem} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>ท้ายบิล</div>
        </div>
      ),
      selector: row => row.discountEndBill,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discountEndBill} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>คะแนน</div>
        </div>
      ),
      selector: row => row.discountPoint,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discountPoint} />
    },
    {
      name: 'ยอดสุทธิ',
      selector: row => row.amount,
      width: '140px',
      cell: (row, index, column, id) => (
        <div style={{ color: '#2DC76D', fontWeight: 'bold' }}>
          <CurrencyFormatC val={row.amount} />
        </div>
      )
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div className="fs-10 text-center">ไม่มีภาษี</div>
        </div>
      ),
      selector: row => row.amountNoVat,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.amountNoVat} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div className="fs-10 text-center">มีภาษี</div>
        </div>
      ),
      selector: row => row.amountWithVat,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.amountWithVat} />
    },
    {
      name: 'ภาษีมูลค่าเพิ่ม',
      selector: row => row.vat,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.vat} />
    },
    {
      name: 'จำนวน',
      selector: row => row.quantity,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.quantity} />
    },
    {
      name: 'จำนวนบิล',
      selector: row => row.billQuantity,
      width: '130px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billQuantity} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>จำนวนบิล</div>
          <div className="fs-10 text-center">ที่ยกเลิก</div>
        </div>
      ),
      selector: row => row.billCancelQuantity,
      width: '130px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billCancelQuantity} />
    },
    {
      name: (
        <div className="lh-sm">
          <div className="text-red-400">จำนวนบิล</div>
          <div className="fs-10 text-center text-red-400">การคืนสินค้า</div>
        </div>
      ),
      selector: row => row.billReturnQuantity,
      width: '130px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billReturnQuantity} />
    },
    {
      name: (
        <div className="lh-sm">
          <div className="text-red-400">มูลค่าสินค้า</div>
          <div className="fs-10 text-center text-red-400">การคืนสินค้า</div>
        </div>
      ),
      selector: row => row.billReturnAmount,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billReturnAmount} />
    },
    {
      name: 'พิมพ์บิลสิ้นวัน',
      selector: row => row.inventories,
      width: '170px',
      cell: (row, index, column, id) => (
        <div>
          <Button
            type="button"
            className="w-[118px]"
            onClick={() => {
              window.open(
                `/${businessSlug}/report/daily-sales-summary/${row.posDate}?branchId=${searchdata.branchID || branch?.value || ''
                }`,
                '_blank'
              );
            }}
            style={{
              color: '#2DC76D',
              background: '#FFF',
              border: '1px solid #2DC76D'
            }}
          >
            พิมพ์บิลสิ้นวัน
          </Button>
        </div>
      )
    }
  ];

  const columnsPos = [
    {
      name: 'POS',
      selector: row => row.posName,
      width: '110px',
      cell: (row, index, column, id) => (
        <div className="flex items-center">
          <img src={imgpos} className="w-[18px] mr-1" /> {row.posName}
        </div>
      )
    },
    {
      name: 'ยอดรวม',
      width: '110px',
      selector: row => row.total,
      cell: (row, index, column, id) => <CurrencyFormatC val={row.total} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>ITEM</div>
        </div>
      ),
      selector: row => row.discountItem,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discountItem} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>ท้ายบิล</div>
        </div>
      ),
      selector: row => row.discountEndBill,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discountEndBill} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>ส่วนลด</div>
          <div>คะแนน</div>
        </div>
      ),
      selector: row => row.discountPoint,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.discountPoint} />
    },
    {
      name: 'ยอดสุทธิ',
      selector: row => row.amount,
      width: '140px',
      cell: (row, index, column, id) => (
        <div style={{ color: '#2DC76D', fontWeight: 'bold' }}>
          <CurrencyFormatC val={row.amount} />
        </div>
      )
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div>ไม่มีภาษี</div>
        </div>
      ),
      selector: row => row.amountNoVat,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.amountNoVat} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div>มีภาษี</div>
        </div>
      ),
      selector: row => row.amountWithVat,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.amountWithVat} />
    },
    {
      name: 'ภาษีมูลค่าเพิ่ม',
      selector: row => row.vat,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.vat} />
    },
    {
      name: 'จำนวน',
      selector: row => row.quantity,
      width: '120px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.quantity} />
    },
    {
      name: 'จำนวนบิล',
      selector: row => row.billQuantity,
      width: '130px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billQuantity} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>จำนวนบิล</div>
          <div className="fs-10">ที่ยกเลิก</div>
        </div>
      ),
      selector: row => row.billCancelQuantity,
      width: '130px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billCancelQuantity} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>จำนวนบิล</div>
          <div className="fs-10">การคืนสินค้า</div>
        </div>
      ),
      selector: row => row.billReturnQuantity,
      width: '130px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billReturnQuantity} />
    },
    {
      name: (
        <div className="lh-sm">
          <div>มูลค่าสินค้า</div>
          <div className="fs-10">การคืนสินค้า</div>
        </div>
      ),
      selector: row => row.billReturnAmount,
      width: '140px',
      cell: (row, index, column, id) => <CurrencyFormatC val={row.billReturnAmount} />
    },
    {
      name: 'พิมพ์บิลสิ้นวัน',
      selector: row => row.inventories,
      width: '140px',
      cell: (row, index, column, id) => (
        <div>
          <Button
            type="button"
            className="w-[118px]"
            onClick={() => {
              window.open(
                `/${businessSlug}/report/daily-sales-summary/${row.posDate}?branchId=${searchdata.branchID || branch?.value || ''
                }&branchPosId=${row.branchPosId}`,
                '_blank'
              );
            }}
            style={{
              color: '#2DC76D',
              background: '#FFF',
              border: '1px solid #2DC76D'
            }}
          >
            พิมพ์บิลสิ้นวัน
          </Button>
        </div>
      )
    }
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '52px'
      }
    },
    headCells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        color: 'rgba(76, 78, 100, 0.87)',
        fontFamily: 'Sarabun',
        fontSize: '14px',
        background: ' #F5F5F7',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontWeight: '500'
      }
    },
    cells: {
      style: {
        paddingLeft: '15px',
        paddingRight: '15px',
        color: 'rgba(76, 78, 100, 0.87)',
        fontFamily: 'Sarabun',
        fontSize: '14px',
        fontWeight: '300'
      }
    },
    pagination: {
      style: {
        borderBottomRightRadius: '0.75rem',
        borderBottomLeftRadius: '0.75rem'
      }
    }
  };

  const formatData = rawData => {
    const updateSubPos = [];
    const updateData = rawData?.map((item, index) => {
      const date = moment(item.date).format('DD-MM-YYYY');
      if (item?.pos !== null) {
        const updateSub = item.pos.map(posItem => ({
          posDate: date,
          posName: posItem.branch_pos_name,
          branchPosId: posItem.branch_pos_id,
          total: posItem.total || 0,
          discountItem: posItem.discount_item || 0,
          discountEndBill: posItem.discount_amount || 0,
          discountPoint: posItem.discount_points || 0,
          amount: posItem.total_price,
          amountNoVat: posItem.price_without_vat || 0,
          amountWithVat: posItem.price_with_vat || 0,
          totalPrice: posItem.total_price || 0,
          vat: posItem.vat || 0,
          quantity: posItem.count_bill_completed || 0,
          billQuantity: posItem.count_bill_completed || 0,
          billCancelQuantity: posItem.count_bill_cancel || 0,
          billReturnQuantity: posItem.count_bill_return || 0,
          billReturnAmount: posItem.price_return || 0,
          index: index + 1
        }));
        updateSubPos.push(...updateSub);
      }
      return {
        posDate: date,
        total: item.total || 0,
        discountItem: item.discount_item || 0,
        discountEndBill: item.discount_amount || 0,
        discountPoint: item.discount_points || 0,
        amount: item.total_price,
        amountNoVat: item.price_without_vat || 0,
        amountWithVat: item.price_with_vat || 0,
        totalPrice: item.total_price || 0,
        vat: item.vat || 0,
        quantity: item.count_bill_completed || 0,
        billQuantity: item.count_bill_completed || 0,
        billCancelQuantity: item.count_bill_cancel || 0,
        billReturnQuantity: item.count_bill_return || 0,
        billReturnAmount: item.price_return || 0,
        index: index + 1
      };
    });
    return { updateData: updateData, updateSubPos: updateSubPos };
  };

  const formatBranch = (rawData, isBranch = false) => {
    let updateBranch = [];
    if (isBranch) {
      updateBranch = rawData?.map(item => ({
        value: item.id,
        label: item.name
      }));
    } else {
      updateBranch = rawData?.map(item => ({
        value: item.id,
        label: item.branch_name
      }));
    }
    return updateBranch;
  };

  const [filterText, setFilterText] = useState('');
  const filteredItems = reportdata?.filter(
    item => item.posDate && item.posDate.toLowerCase().includes(filterText.toLowerCase())
  );

  // คำนวณข้อมูลสำหรับหน้าปัจจุบัน
  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredItems?.slice(startIndex, endIndex) || [];
  };

  // Handle page change
  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // Handle rows per page change
  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page when changing rows per page

    // Force refresh the table
    setTimeout(() => {
      const event = new Event('resize');
      window.dispatchEvent(event);
    }, 100);
  };

  const downloadExcel = () => {
    let startDate;
    let endDate;
    if (moment(searchdata.startDate).format('YYYY-MM-DD') === 'Invalid date') {
      const date = moment();
      startDate = date.subtract(1, 'months').format('YYYY-MM-DD');
      endDate = date.add(1, 'months').format('YYYY-MM-DD');
    } else {
      startDate = moment(searchdata.startDate).format('YYYY-MM-DD');
      endDate = moment(searchdata.endDate).format('YYYY-MM-DD');
    }

    const params = {
      branchId: posBranchObj?.branchId,
      branchPosIds: posBranchObj?.posId,
      sortBy: 'date',
      sortOrder: 'desc',
      startDate: startDate,
      endDate: endDate
    };

    const formattedDate = `${moment(startDate).format('YYYY-MM-DD')}ถึง${moment(endDate).format('YYYY-MM-DD')}`;
    dispatch(reportHandler.getSaleReportExcel(businessSlug, params, formattedDate));
  };

  const ExpandedComponent = ({ data }) => {
    const filterData = pos?.filter(item => item.index === data.index);
    return (
      <div className="hideexpandable pl-[46px] bg-[#DFFFEC] ">
        <DataTable columns={columnsPos} data={filterData} noTableHead={true} />
      </div>
    );
  };

  const handleApply = (event, picker) => {
    setSearchdata(prev => ({
      ...prev,
      startDate: picker.startDate.format('YYYY-MM-DD')
    }));
    setSearchdata(prev => ({
      ...prev,
      endDate: picker.endDate.format('YYYY-MM-DD')
    }));
  };

  const handlerSelectBranchChange = async branch => {
    setBranch(branch);
    setPosSelected([]);
    if (branch) {
      const data = await dispatch(branchHandler.getPOSByBranchId(branch.value));
      if (data) {
        const updateFormat = formatBranch(data?.branchPOS, true);
        setOptionsPos(updateFormat);
      }
      setPosBranchObj({ branchId: branch.value, posId: null });
    } else {
      setOptionsPos([]);
    }
  };

  const updatePosChanges = pos => {
    setPosSelected(pos);
    let temp = posBranchObj;
    temp.posId = pos?.map(item => item.value);
    setPosBranchObj(temp);
  };

  const handleSearch = async () => {
    if (firstLoad.current === true) {
      firstLoad.current = false;
    }
    let startDate;
    let endDate;
    if (moment(searchdata.startDate).format('YYYY-MM-DD') === 'Invalid date') {
      const date = moment();
      startDate = date.subtract(1, 'months').format('YYYY-MM-DD');
      endDate = date.add(1, 'months').format('YYYY-MM-DD');
    } else {
      startDate = moment(searchdata.startDate).format('YYYY-MM-DD');
      endDate = moment(searchdata.endDate).format('YYYY-MM-DD');
    }
    const params = {
      branchId: posBranchObj?.branchId,
      branchPosIds: posBranchObj?.posId,
      sortBy: 'date',
      sortOrder: 'desc',
      startDate: startDate,
      endDate: endDate
    };
    const res = await dispatch(reportHandler.getSaleReport(businessSlug, params));
    const formatedData = formatData(res);
    console.log(formatedData);
    setreportdata(formatedData?.updateData);
    setPos(formatedData?.updateSubPos);
    setCurrentPage(1); // Reset to first page when new search is performed
  };

  const CustomPagination = ({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => {
    const count = Math.ceil(rowCount / rowsPerPage);
    const pageSizeOptions = [5, 10, 25, 50, 100];

    return (
      <>
        <div
          className="d-flex align-items-center justify-content-end mx-0 pt-3 pb-5"
          style={{ borderTop: '1px solid #e0e0e0' }}
        >
          <div className="fs-12 d-flex justify-content-start me-5" style={{ color: '#4C4E64' }}>
            <p>
              <span className="me-2">จำนวนรายการต่อหน้า</span>
              <select
                className="form-select form-select-sm d-inline-block me-4"
                style={{ width: 'auto', minWidth: '70px' }}
                value={rowsPerPage}
                onChange={e => {
                  onChangeRowsPerPage(Number(e.target.value), 1);
                }}
              >
                {pageSizeOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {rowCount === 0
                ? 0
                : currentPage * rowsPerPage + 1 - rowsPerPage > rowCount
                ? rowCount
                : currentPage * rowsPerPage + 1 - rowsPerPage}
              <span className="mx-1 fs-18">-</span>
              {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage}
              <span className="mx-1">of</span> {rowCount}
            </p>
          </div>

          <div className="d-flex justify-content-end">
            <ReactPaginate
              previousLabel={<i className="icon-prev"></i>}
              nextLabel={<i className="icon-next"></i>}
              forcePage={currentPage !== 0 ? currentPage - 1 : 0}
              onPageChange={page => {
                onChangePage(page.selected + 1);
              }}
              pageCount={count || 1}
              breakLabel={'...'}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              activeClassName={'active'}
              pageClassName={'page-item'}
              nextLinkClassName={'page-link'}
              nextClassName={'page-item next'}
              previousClassName={'page-item prev'}
              previousLinkClassName={'page-link'}
              pageLinkClassName={'page-link'}
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName={'pagination react-paginate pagination-sm justify-content-end pr-1 mt-1'}
              disabledClassName={'disabled'}
            />
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    async function fetchAllBranch() {
      if (businessId) {
        const data = await dispatch(businessHandler.getBusinessListBranch(businessId));
        const formatedData = formatBranch(data.business.branch.filter(e => e.is_status));
        setOptionsBranch(formatedData);
      }
    }
    fetchAllBranch();
  }, [businessId]);

  useEffect(() => {
    async function getInitBusinessData() {
      const data = await dispatch(businessHandler.getBusinessBySlug(businessSlug));
      if (data) {
        setBusinessId(data.business.id);
      }
    }
    getInitBusinessData();
  }, []);

  return (
    <div>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="#" className="tc-7  text-decoration-none">
              รายงาน
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {' '}
            ยอดขายรายวัน{' '}
          </li>
        </ol>
      </nav>

      <div className="card card-st-2 mb-4">
        <div className="card-body  py-4">
          <div className="fw-bold mb-3">ค้นหาขั้นสูง</div>

          <div className="row">
            <div className="col-xl-2 col-lg-3 col-2">
              <Select
                as="select"
                name="branch"
                onChange={e => handlerSelectBranchChange(e)}
                className={`w-100 select-st-1 sm pd`}
                options={optionsBranch}
                placeholder="เลือกสาขา"
                isClearable={true}
              />
            </div>
            <div className="col-xl-2 col-lg-3 col-2">
              <MultiSelect
                options={optionsPos}
                className={`w-100 select-st-1 pd`}
                value={posSelected}
                onChange={e => updatePosChanges(e)}
                labelledBy="Select"
                overrideStrings={{
                  selectAll: 'ทั้งหมด',
                  allItemsAreSelected: 'ทั้งหมด',
                  selectSomeItems: 'เลือก Pos...'
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-2">
              <DateRangePicker
                initialSettings={{
                  startDate: searchdata.startDate,
                  endDate: searchdata.endDate,
                  locale: {
                    format: 'DD/MM/YYYY'
                  }
                }}
                onApply={handleApply}
              >
                <input type="text" className="form-control iconcalendar-right" />
              </DateRangePicker>
            </div>
            <div className="col-auto">
              <Button
                type="button"
                className="btn-st-3  "
                style={{ width: '100px' }}
                onClick={handleSearch}
                disabled={posBranchObj === null || posBranchObj.branchId === null}
              >
                {' '}
                ค้นหา
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-st-2">
        <div className="card-body px-0 py-4">
          <div className="d-flex align-items-center px-4 mb-4">
            <button className="btn btn-export-st-1 me-auto" onClick={downloadExcel}>
              Export
            </button>
            <div>
              <input
                type="text"
                className="form-control form-st-4"
                placeholder="ค้นหา"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
              />
            </div>
          </div>
          <DataTable
            columns={columns}
            data={getPaginatedData()}
            customStyles={customStyles}
            pagination
            paginationServer
            paginationTotalRows={filteredItems?.length || 0}
            paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
            paginationPerPage={rowsPerPage}
            paginationDefaultPage={currentPage}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            paginationComponentOptions={paginationComponentOptions}
            paginationComponent={props => (
              <CustomPagination
                rowCount={filteredItems?.length || 0}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
              />
            )}
            noDataComponent={<div className="p-4 text-center">ไม่พบข้อมูล</div>}
            expandableRows
            expandableRowsComponent={ExpandedComponent}
          />
        </div>
      </div>
    </div>
  );
}
